import * as React from "react"
import type { SVGProps } from "react"
const SvgFireMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 15.24q-2.6 0-4.42-1.82A6 6 0 0 1 1.76 9q0-1.92 1.14-4a14 14 0 0 1 3.17-3.8Q6.77.63 7.5.94q.74.3.74 1.17v.38q0 .52.36.9.38.36.9.36.27 0 .5-.08a1 1 0 0 0 .36-.26 1 1 0 0 1 .64-.36.8.8 0 0 1 .67.19q1.18 1.02 1.87 2.58.7 1.55.7 3.19 0 2.6-1.82 4.42A6 6 0 0 1 8 15.24M3.8 9a3.8 3.8 0 0 0 .98 2.58l-.03-.2a3 3 0 0 1 .8-1.66L8 6.99l2.45 2.73q.33.36.53.79.21.42.27.86l-.01.1-.02.13q.45-.5.71-1.17.26-.68.26-1.43a6 6 0 0 0-1.17-3.61 4 4 0 0 1-1.52.4 3.3 3.3 0 0 1-3.11-2.14 10 10 0 0 0-1.93 2.64Q3.8 7.64 3.8 9M8 10l-.94 1.1q-.15.18-.24.4-.08.2-.08.43 0 .53.36.9.38.36.9.36.53 0 .9-.36.36-.38.36-.9a1.3 1.3 0 0 0-.32-.84z" />
  </svg>
)
export default SvgFireMini
